<template>
  <CCard>
    <CCardHeader style="display: inline-flex">
      <slot name="header">
        <CIcon name="cil-grid" />Revenue Report
      </slot>
      <VueCtkDateTimePicker
          :overlay=true
          :range=true
          :no-label=true
          label="Select Date Range"
          id="RangeDatePicker"
          format="YYYY-MM-DD"
          formatted="ll"
          color="#FF2E75"
          v-model="date_range"
          :max-date = current_date
      >
      </VueCtkDateTimePicker>
    </CCardHeader>
    <CCardHeader>
      <CButton class="center-div btn-block w-50 h-50" color="primary" @click="showReport" v-if="loading===false">Show</CButton>
<!--      <CButton class="center-div btn-block w-50 h-50" color="primary" @click="exportReport" v-if="loading===false">Export</CButton>-->
    </CCardHeader>
    <CCardBody v-if="show">
      <v-client-table :data="revenues" :columns="columns" :options="options">
      </v-client-table>
      <!-- <CButton class="center-div btn-block w-50 h-50" color="primary" v-if="loading===false">Load More</CButton> -->
    </CCardBody>
    <!-- <data-table :headings="columns" :data="revenues" @loadData="loadData"></data-table> -->
  </CCard>
</template>

<script>
import moment from 'moment';
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "AdPlay",
  data() {
    return {
      current_date: moment().clone().format('YYYY-MM-DD hh:mm').toString(),
      date_range:  {
        'start' : null,
        'end' : null
      },
      show: false,
      loading: false,
      selected_report: 'Revenue Report',
      // skip: 0,
      revenues: [],
      columns: [
        "date",
        "count",
        // "Total Revenue",
        // "Total Subscription Revenue",
        // "Total Active Subscriber",
        // // "Total Count subscription Number",
        // "New Subscription Attempt",
        // "New Subscription Revenue",
        // "New Subscription count",
        // "Re-order Attempt",
        // "Re-order Revenue",
        // "Re-order count",
        // "On-Demanded Count",
        // "On-Demanded Revenue",
      ],
      options: {
        sortable: [],
        perPage: 10,
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
        // perPageValues:[],

      },
    }
  },
  // mounted:function() {
  //   this.loadingData();
  // },
  methods: {
    // loadData(){
    //   this.loadingData();
    // },
    showReport(){
      this.show=false;
      this.revenues = [];
      this.loadingData();
    },
    loadingData(){
      axios({
        method: 'post',
        url: `${ADMIN_URL}/reports/cpa`,
        data: {
          date_range: this.date_range,
          skip: this.skip
        }
      })
          .then(response => {
            this.loading = false;
            this.show = true;
            this.revenues = response.data.data;
            this.skip = this.revenues.length;
          })
          .catch(() => {
            this.$swal('Error', 'Something Went Wrong', 'error');
          });
    },
    exportReport(){
      this.exporting = true;
      axios({
        method: 'post',
        url: `${ADMIN_URL}/export-report`,
        responseType: 'blob',
        data: {
          date_range: this.date_range,
          report: this.selected_report,
          // coupon_id: this.coupon.id,
          // subcategory_id: this.subcategory.id,
          // date_type: this.date_type
        }
      })
          .then(response => {
            this.exporting = false;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', process.env.VUE_APP_NAME+'_'+this.selected_report+'_' + moment(this.date_range.start).format('YYYY-MM-DD') + '~' + moment(this.date_range.end).format('YYYY-MM-DD') +'.xlsx');
            document.body.appendChild(link);
            link.click();
            this.$swal('Report Exported Successfully', '', 'success');
          })
          .catch(() => {
            this.exporting = false;
            this.$swal('Error', 'Something Went Wrong', 'error');
          });
    }
  }
}
</script>

<style scoped>

</style>
